export class DynamicDateFormat {
  mode: 'month' | 'year' | 'multi-year';

  get parse() {
    if (this.mode !== 'multi-year') {
      return {
        dateInput: 'MM/DD/YYYY',
      };
    } else {
      return {
        dateInput: 'MM/YYYY',
      };
    }
  }

  get display() {
    if (this.mode !== 'multi-year') {
      return {
        dateInput: 'MM/DD/YYYY', // Display format on the input field
        monthYearLabel: 'MMMM YYYY', // Format for the month and year in the datepicker
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      };
    } else {
      return {
        dateInput: 'MM/YYYY', // Display format on the input field
        monthYearLabel: 'MM YYYY', // Format for the month and year in the datepicker
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MM YYYY',
      };
    }
  }
}
